import React from "react";

import { ForwardToInboxRounded } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";

import useMainState from "../../../../config/context/mainStateContext";
import { GreyPallet } from "../../../../config/styles";

import ModalDevMessage from "./ModalDevMessage";

import MainText from "../../../../components/MainText";

export default function DevChatConfig() {
  const { userEnableToInteract } = useMainState();

  const [showModal, setShowModal] = React.useState(false);

  const handleClick = () => {
    if (userEnableToInteract("login")) {
      setShowModal(true);
    }
  };

  React.useEffect(() => {}, []);

  return (
    <Box mt={4} display={"flex"} justifyContent={"start"}>
      {showModal && <ModalDevMessage onClose={() => setShowModal(false)} />}

      <Chip
        label={
          <Box display={"flex"} alignItems={"center"} style={{ color: GreyPallet.Regular }}>
            <ForwardToInboxRounded fontSize={"small"} sx={{ mr: 1 }} />
            <MainText size="small" color="regular">
              Mensagem para o Dev
            </MainText>
          </Box>
        }
        variant={"filled"}
        style={{ borderWidth: 3 }}
        onClick={handleClick}
      />
    </Box>
  );
}
